import type { GachaDetail } from '~/types/resources/gachaDetail';

export const isGachaContentDownloadable = (
  contentDownload: GachaDetail['content_download']
): boolean => {
  if (contentDownload.is_active === false) return false;
  if (contentDownload.start_at == null && contentDownload.end_at == null)
    return true;

  const currentDate = new Date();
  if (contentDownload.start_at == null) {
    if (contentDownload.end_at == null) return false;
    return currentDate < new Date(contentDownload.end_at);
  }
  if (contentDownload.end_at == null)
    return currentDate > new Date(contentDownload.start_at);
  return (
    new Date(contentDownload.start_at) < currentDate &&
    currentDate < new Date(contentDownload.end_at)
  );
};
